import Swiper from 'swiper/swiper-bundle.min';

export default () => {
  const stockSlider = new Swiper('.js-stock-slider', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    resistanceRatio: 0,
    navigation: {
      nextEl: '.stock-slider-next',
      prevEl: '.stock-slider-prev',
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1260: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    }
  });
}


// WEBPACK FOOTER //
// ./resources/assets/js/blocks/stock/index.js